import { render, staticRenderFns } from "./IOLTCDGA.vue?vue&type=template&id=65fae0c5&scoped=true"
import script from "./IOLTCDGA.vue?vue&type=script&lang=ts"
export * from "./IOLTCDGA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fae0c5",
  null
  
)

export default component.exports